/**
 * "SALE ENDS TODAY!" notice for product cards.
 *
 * Theme cards (snippets/product-block.liquid) and Boost cards (Boost Turbo price template)
 * both output a hidden <div class="lc-promo-ends" data-promo-end="2026-10-04 2026-10-04">,
 * listing every variant's custom.promo_end_date. This reveals it when any date is today in
 * Calgary time (store timezone), and re-checks whenever cards are added or redrawn
 * (Boost filtering/sorting/paging, AJAX-loaded recommendations).
 *
 * Testing: add ?lc_promo_today=YYYY-MM-DD to the URL to pretend it is that date.
 */
(() => {
  const override = new URLSearchParams(window.location.search).get('lc_promo_today');
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Edmonton', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(new Date());
  const part = (type) => parts.find((p) => p.type === type).value;
  const today = /^\d{4}-\d{2}-\d{2}$/.test(override || '')
    ? override
    : `${part('year')}-${part('month')}-${part('day')}`;

  let queued = false;
  const apply = () => {
    queued = false;
    document.querySelectorAll('[data-promo-end]').forEach((el) => {
      const dates = (el.dataset.promoEnd || '').split(/\s+/);
      el.classList.toggle('is-ending-today', dates.some((d) => d.slice(0, 10) === today));
    });
  };

  apply();
  new MutationObserver(() => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(apply);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
